<template>
  <div>
    <div
      v-if="fetchDataState.loading"
      class="text-xs-center my-5 pt-5"
    >
      <v-progress-circular
        :size="50"
        color="black"
        indeterminate
      />
    </div>

    <div v-else>
      <v-layout row>
        <v-flex>
          <h1>{{ $tc('Followed artists', 2) }}</h1>
        </v-flex>
      </v-layout>

      <masonry
        :cols="{default: 3, 1200: 2, 960: 1}"
        :gutter="40"
      >
        <ArtistCard
          class="mb-4"
          v-for="artist in artists"
          :key="artist.id"
          :artist="artist"
        >
          <template #action-btns>
            <v-divider/>
            <v-card-actions class="pa-0">
              <tk-btn
                flat
                block
                @click.stop.prevent="onRemove(artist)"
                :loading="unsubscribeState.loading && unsubscribeState.deletable_id === artist.my_subscription_id"
              >
                <span>{{ $t('Unsubscribe') }}</span>
              </tk-btn>
            </v-card-actions>
          </template>
        </ArtistCard>
      </masonry>

      <div
        class="text-xs-right mt-4"
        v-if="artists.length"
      >
        <v-pagination
          @input="fetchData"
          @click.native="scrollTop"
          :disabled="fetchDataState.loading"
          :value="pagination.currentPage"
          :length="pagination.lastPage"
          :total-visible="7"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { useFormAction, usePromise } from '../../utils/Promis'
import { RepositoryFactory } from '../../services/RepositoryFactory'
import ArtistCard from '../../components/Domain/Artist/Card/ArtistCard'
import { theArtistRepository } from '../../services/artist/ArtistRepository'

const artistsRepo = RepositoryFactory.artists()

// TODO refactor, pages favorites and subscription have similar logic
export default {
  name: 'ProfileSubscriptionListPage',
  components: { ArtistCard },
  data () {
    return {
      artists: [],
      pagination: {},
      loading: true,
      fetchDataState: {
        loading: false,
      },
      unsubscribeState: {
        deletable_id: null,
        loading: false
      }
    }
  },

  created () {
    this.fetchData(1)
  },

  methods: {
    async fetchData (page) {

      this.fetchDataState = usePromise(async () => {

        const res = await artistsRepo.profileSubscriptions(page)

        this.artists = res.data
        this.pagination = res.pagination
      })
    },

    async onRemove (artist) {
      if (!artist.my_subscription_id) return
      const pos = this.artists.findIndex(art => art.id === artist.id)
      if (pos !== -1) {
        this.unsubscribeState = useFormAction(async () => {
          await this.$auth.removeSubscription(artist.my_subscription_id)
          this.artists.splice(pos, 1)
          await this.$auth.refresh()
        })
        this.unsubscribeState.deletable_id = artist.my_subscription_id

      }
    },

    scrollTop () {
      VueScrollTo.scrollTo({ offset: 0 })
    },


  }
}
</script>

<style scoped>

</style>
